<template>
  <section class="container">
    <!-- style="height:100%;" -->
    <van-dialog id="van-dialog" />

    <van-popup v-model="showImg">
      <van-image width="7rem" class="timeImg" :src="orders.url" />
    </van-popup>
    <van-pull-refresh v-model="refresh_loading" @refresh="handleRefresh">
      <!-- <van-image class="timeImg" :src="TimeImg" /> -->
      <div class="modal_header">
        <div class="modal_header__title">停车缴费</div>
        <div class="modal_header__info">¥{{ payMoney.toFixed(2) }}</div>
        <div class="modal_header__countdown" v-if="orders.url&&config.projectName == 'GCTC'">
          <van-button type="info" plain @click="showImgs" size="small">
            查看图片
          </van-button>
        </div>
        <div class="modal_header__countdown">
          支付倒计时:
          <van-count-down @finish="handleRefresh"
            :time="$enumObject.providerConfig[config.projectName].otherConfig.paymentCountdown" style="color:#FF3366;"
            ref="countDown" />
        </div>
      </div>
      <div class="order_info">
        <van-cell title="车牌号码" :value="orders.cardNumber" />
        <van-cell title="停车位置" :value="orders.parkDesc ? orders.parkDesc.split('-')[0] : orders.parkDesc" />
        <van-cell title="入场时间" :value="orders.entranceDate" />
        <van-cell title="停车时长" :value="orders.parkingTime" />
        <van-cell title="应缴金额" :value="'¥' + orders.chargeMoney.toFixed(2)" />
        <!-- 优惠券单元格 -->
        <van-coupon-cell :coupons="coupons" :chosen-coupon="chosenCoupon" @click="showList = true" />
        <!-- 优惠券列表 -->
        <van-popup v-model="showList" position="bottom">
          <van-coupon-list :coupons="coupons" :chosen-coupon="chosenCoupon" :disabled-coupons="disabledCoupons"
            @change="onChange" @exchange="onExchange" />
        </van-popup>
        <van-cell title="实缴费用" :value="orders.givenMoney==0?'¥' + payMoney.toFixed(2):'已缴押金'" />
        <van-cell :value="fristPayWay.name" @click="pay_way_show = true" is-link>
          <template slot="title">
            <span class="custom-title">支付方式</span>
            <van-tag v-if="fristPayWay.frist" style="margin-left:5px;" type="danger">
              推荐
            </van-tag>
          </template>
        </van-cell>
      </div>
    </van-pull-refresh>
    <div class="btn_box bottom">
      <van-button :disabled="!(payWay.length>0&&orders.givenMoney==0)" @click="submit" size="large" class="blue-btn">
        {{$enumObject.providerConfig[config.projectName].otherConfig.PayBtn}}
      </van-button>
    </div>

    <!-- 支付方式选择 -->
    <van-action-sheet v-model="pay_way_show" :actions="payWay" @select="payWayChange" close-on-click-action
      safe-area-inset-bottom cancel-text="取消" description="请选择下列支付方式" @cancel="onCancel" />
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import { Image, Popup, CouponCell, CouponList, PullRefresh, CountDown, Tag, ActionSheet, Dialog } from 'vant'
import { JH_UnderOrderByMiddleware, SNInsertData, WO_UnderOrderByMiddleware, NJCB_UnderOrderByMiddleware, YINLIAN_UnderOrderByMiddleware, LESHUA_UnderOrderByMiddleware, ABC_UnderOrderByMiddleware, CCB_UnderOrderByMiddleware, SNPayEncrypt } from '@/api/transaction'
import { weixinPay, aliPay, unifiedOrder } from '@/api/wechat'
import { getStopCarInfo } from '@/api/park'
import { isWhatsPayWay, parseTime, getTimeval, deepClone, isSnYiFuBao, sortASCII, EncryptReplace } from '@/utils'
import md5 from 'js-md5'
import QS from 'qs'
import { setLocalStorage, getLocalStorage } from '@/utils/auth'
import { Base64 } from 'js-base64'
import config from '@/config/index'
import autumn from '@/assets/insurance_images/autumn.png'

export default {
  props: {
    orders: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    [Image.name]: Image,
    [Popup.name]: Popup,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [PullRefresh.name]: PullRefresh,
    [CountDown.name]: CountDown,
    [Tag.name]: Tag,
    [ActionSheet.name]: ActionSheet,
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    payMoney () {
      let price = 0;
      if (!this.orders.chargeMoney && !this.orders.paidMoney) {
        return price
      }

      if (this.orders.discountType > 0) {
        price = this.orders.paidMoney;
      } else {
        price = this.orders.chargeMoney;
      }

      let m = 0;
      if (this.chosenCoupon >= 0) {
        m = price - this.coupons[this.chosenCoupon].value / 100;
        return m < 0 ? 0 : m;
      } else {
        return price;
      }
    },
    //优先支付方式
    fristPayWay () {
      // 如果选择了支付渠道
      let initPayWay = this.payWayChannel != null ? this.payWayChannel.payChannel : null
      let payWay = null
      if (initPayWay) {
        payWay = initPayWay
      } else if (
        getLocalStorage('defaultPayway') &&
        this.payWay.includes(getLocalStorage('defaultPayway')) //默认支付方式中同样存在该支付值
      ) {
        payWay = getLocalStorage('defaultPayway')
      } else {
        for (let i = 0; i < this.payWay.length; i++) {
          if (this.payWay[i].frist == 1) {
            payWay = this.payWay[i].payChannel
          }
        }
        if (!payWay && this.payWay[0]) {
          payWay = this.payWay[0].payChannel
        }
      }
      console.log(this.payWay)
      return this.$enumObject.getPayWay(payWay, this.payWay)
    },
    ...mapGetters([
      'wx_userInfo',
      'zfb_userInfo',
      'appconfig',
      'NBPSS',//平台用户信息
      'PayConfig',  //支付配置
    ])
  },
  watch: {
    PayConfig: function (newVal, oldVal) {
      if (newVal == oldVal) {
        return
      }
      this.payWay = newVal
    }
  },
  data () {
    return {
      showImg: false,
      TimeImg: autumn,
      show: true,
      config,
      outTradeNo: null,
      payWay: [], //支付渠道
      payWayChannel: null, //默认建行聚合支付
      pay_way_show: false,
      refresh_loading: false,
      under_Order_Loading: null,
      showList: false,
      chosenCoupon: -1,
      coupons: [
        // {
        //   available: 1,
        //   condition: '无使用门槛\n最多优惠12元',
        //   reason: '',
        //   value: 150,
        //   name: '优惠券名称',
        //   startAt: 1489104000,
        //   endAt: 1514592000,
        //   valueDesc: '1.5',
        //   unitDesc: '元'
        // }
      ],
      disabledCoupons: [
        // {
        //   id: 1, //优惠券id
        //   discount: 0, //折扣券 折值 整数 为0不显示折
        //   denominations: 100, //优惠券金额 单位分
        //   originCondition: 0, //满减规则金额 单位分 为0显示无门槛
        //   value: 0, //折扣券优惠金额，单位分
        //   name: '优惠券名称', //优惠券名称
        //   description: '描述信息', //描述信息
        //   reason: '', //不可用原因，优惠券不可用时展示
        //   startAt: 1489104000, //卡有效开始时间 (时间戳, 单位秒)
        //   endAt: 1514592000 //卡失效日期 (时间戳, 单位秒)
        // }
      ]
    }
  },
  created () {
    this.getPayConfig()

  },
  methods: {
    showImgs () {
      this.showImg = true
    },
    //获取支付配置
    getPayConfig () {
      let _this = this
      let params = {
        parkId: _this.orders.parkId,
        payChannelName: isWhatsPayWay()
      }
      // 获取支持的支付渠道
      this.$store.dispatch('transaction/SetPayconfig', params)
      //苏宁支付易付宝回调JS-SDK调用方法


    },
    handleRefresh () {
      let _this = this
      // query内数据存在,使用地址中存在的订单信息查询该订单
      let params = {
        cardNumber: _this.orders.cardNumber,
        parkId: _this.orders.parkId || -1,
        largeCar: _this.orders.largeCar || false,
        code: Number(_this.$route.query.type) || _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,
        isMark: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,
        sign: '',
        // nonceStr: "840BF8E41414D2C59612A06EE52AD390",
      }
      getStopCarInfo(params)
        .then(response => {
          let data = response.body
          if (data.entranceDate) {
            let exitDate = data.exitDate || parseTime(new Date())
            data.parkingTime = getTimeval(data.entranceDate, exitDate)
            if (data.parkingTime == '0天0时0分' && this.config.projectName == 'JNJT') {
              data.parkingTime = '不足1小时'
            }
          }
          _this.orders = deepClone(data)
          _this.refresh_loading = false
          _this.$nextTick(() => {
            //异步执行
            _this.$refs.countDown.reset()
          })
        })
        .catch(error => {
          _this.refresh_loading = false
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    onChange (index) {
      this.showList = false
      this.chosenCoupon = index
    },
    onExchange (code) {
      console.log(code)
      // this.coupons.push(code)
    },
    // 点击支付方式
    payWayChange (item) {
      this.payWayChannel = JSON.parse(JSON.stringify(item))
    },
    // 碳积分
    Carbonintegral_UnderOrder_Submit () {
      let _this = this
      const hasPhone = this.NBPSS.phone
      if (!hasPhone) {
        _this.$router.push('/login?redirect=/my-order')
        return
      }
      _this.under_Order_Loading = _this.$toast.loading('加载中...')
      let params = {
        operateId: _this.orders.operatorId,
        discountMoney: (_this.orders.discount).toFixed(2).toString(), //折扣金额
        chargeMoney: (_this.orders.chargeMoney).toFixed(2).toString(), //应收金额
        cardNumber: _this.orders.cardNumber, //车牌号
        parkId: _this.orders.parkId, //停车场Id,
        parkingNumber: "",//车位号
        parkName: _this.orders.parkDesc, //停车场名称
        orderType: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边 3预约 4 关系 5 包月
        orderStatus: 0,//订单状态
        billingStatus: 0,//开票状态
        payType: 75,
        orderPayTime: parseTime(new Date()),
        wxOpenid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        otherId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        zfbUserid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        otherPlatformId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        returnUrl: `http://${document.domain}/jn-pay-result`,
        phone: this.NBPSS ? this.NBPSS.phone ? this.NBPSS.phone : '' : '',
        platformId: _this.orders.id.toString(), //停车记录id
        paidMoney: (_this.payMoney * 100).toFixed(0),//实付金额 _this.payMoney
        //other1: '67',
        outTradeNo: `${parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + Math.round(Math.random() * 100)}_${_this.orders.id}_2`,
        paidTime: parseTime(new Date()),
        isParkingOrRoadside: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//路内路外
        isJfOrQfbj: "JF",
        remark: _this.orders.discountType,
        isFieldOrDoorway: "场内缴费",
        stayPage: '我要缴费查询支付页面',
        kernel: isWhatsPayWay() == 'WX' ? 1 : 0 //0支付宝 1微信
      }
      JH_UnderOrderByMiddleware(params).then(res => {
        _this.under_Order_Loading.clear()
        if (res.status === 1001) {
          _this.$router.push('/pay-result')
        } else if (res.status == 1003) {
          Dialog.confirm({
            title: '友情提示',
            message: '尊敬的用户您好，您当前剩余的碳积分不足，现在总共要缴纳' + res.body.totalAmount + '元，目前您剩余' + Number(res.body.tjfPaidMoney) * 100 + '碳积,余下' + res.body.unionPayMoney + '元系统使用银联支付进行缴纳费用，请您知晓。',
          })
            .then(() => {
              // on confirm
              let paramss = {
                operateId: _this.orders.operatorId,
                discountMoney: (_this.orders.discount).toString(), //折扣金额
                chargeMoney: (_this.orders.chargeMoney).toString(), //应收金额
                cardNumber: _this.orders.cardNumber, //车牌号
                parkId: _this.orders.parkId, //停车场Id,
                parkingNumber: "",//车位号
                parkName: _this.orders.parkDesc, //停车场名称
                orderType: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边 3预约 4 关系 5 包月
                orderStatus: 0,//订单状态
                billingStatus: 0,//开票状态
                payType: Number(res.body.tjfPaidMoney) == 0 ? 63 : 76,
                orderPayTime: parseTime(new Date()),
                wxOpenid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
                otherId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
                zfbUserid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
                otherPlatformId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
                returnUrl: `http://${document.domain}/jn-pay-result`,
                notifyUrl: Number(res.body.tjfPaidMoney) == 0 ? `${config.authBaseURL}/weChat/notifyUrlV3/api/UnionPayCallback` : `${config.authBaseURL}/weChat/notifyUrlV3/api/mixedPaymentCallback`,
                phone: this.NBPSS ? this.NBPSS.phone ? this.NBPSS.phone : '' : '',
                platformId: _this.orders.id.toString(), //停车记录id
                paidMoney: (_this.payMoney * 100).toFixed(0),//实付金额 _this.payMoney
                //other1: '67',
                outTradeNo: `${parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + Math.round(Math.random() * 100)}_${_this.orders.id}_2`,
                paidTime: parseTime(new Date()),
                isParkingOrRoadside: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//路内路外
                isJfOrQfbj: "JF",
                remark: _this.orders.discountType,
                isFieldOrDoorway: "场内缴费",
                stayPage: '我要缴费查询支付页面',
                kernel: isWhatsPayWay() == 'WX' ? 1 : 0 //0支付宝 1微信
              }
              JH_UnderOrderByMiddleware(paramss).then(res => {
                _this.under_Order_Loading.clear()
                if (res.status === 1001) {
                  if (res.body.url) {

                    window.location.href = window.unescape(res.body.url)
                  } else {
                    _this.$router.push('/pay-result')
                  }
                } else {
                  _this.$notify({
                    type: 'danger',
                    message: res.message
                  })
                }
              })
            }).catch(err => {
              _this.under_Order_Loading.clear()
              _this.$notify({
                type: 'danger',
                message: err
              })
            })
            .catch(() => {
              // on cancel
            });
        } else {
          _this.$notify({
            type: 'danger',
            message: res.message
          })
        }
      }).catch(err => {
        _this.under_Order_Loading.clear()
        _this.$notify({
          type: 'danger',
          message: err
        })
      })
    },
    // 银联支付1
    Yinlian_UnderOrder_Submit () {
      let _this = this
      _this.under_Order_Loading = _this.$toast.loading('加载中...')
      let params = {
        operateId: _this.orders.operatorId,
        discountMoney: (_this.orders.discount).toFixed(2).toString(), //折扣金额
        chargeMoney: (_this.orders.chargeMoney).toFixed(2).toString(), //应收金额
        cardNumber: _this.orders.cardNumber, //车牌号
        parkId: _this.orders.parkId, //停车场Id,
        parkingNumber: "",//车位号
        parkName: _this.orders.parkDesc, //停车场名称
        orderType: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//订单类型 1 停车场  2 路边 3预约 4 关系 5 包月
        orderStatus: 0,//订单状态
        billingStatus: 0,//开票状态
        payType: 63,
        orderPayTime: parseTime(new Date()),
        wxOpenid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        otherId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        zfbUserid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        otherPlatformId: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo ? _this.zfb_userInfo.userId : null,
        returnUrl: `http://${document.domain}/jn-pay-result`,
        notifyUrl: `${config.authBaseURL}/weChat/notifyUrlV3/api/UnionPayCallback`,
        phone: this.NBPSS ? this.NBPSS.phone ? this.NBPSS.phone : '' : '',
        platformId: _this.orders.id.toString(), //停车记录id
        paidMoney: (_this.payMoney * 100).toFixed(0),//实付金额 _this.payMoney
        //other1: '67',
        outTradeNo: `${parseTime(new Date(), '{y}{m}{d}{h}{i}{s}') + Math.round(Math.random() * 100)}_${_this.orders.id}_2`,
        paidTime: parseTime(new Date()),
        isParkingOrRoadside: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,//路内路外
        isJfOrQfbj: "JF",
        remark: _this.orders.discountType,
        isFieldOrDoorway: "场内缴费",
        stayPage: '我要缴费查询支付页面',
        kernel: isWhatsPayWay() == 'WX' ? 1 : 0 //0支付宝 1微信
      }
      JH_UnderOrderByMiddleware(params).then(res => {
        _this.under_Order_Loading.clear()
        if (res.status === 1001) {
          if (res.body.url) {
            window.location.href = window.unescape(res.body.url)
          } else {
            _this.$notify({
              type: 'danger',
              message: res.message
            })
          }        }
      }).catch(err => {
        _this.under_Order_Loading.clear()
        _this.$notify({
          type: 'danger',
          message: err
        })
      })
    },

    submit () {
      if (this.payMoney == 0) {
        Dialog.alert({
          title: '温馨提示',
          message: '在免费停车时长内，请直接驶离。',
          confirmButtonColor: '#4B62EC'
        })

        return
      }
      // 根据支付类型提交支付请求
      this[this.fristPayWay.method]()
      this.$store.dispatch('invoice/SetParkId', this.orders.parkId)
      this.orders.outTradeNo = this.outTradeNo
      this.$store.dispatch('invoice/SetPendingBill', [this.orders])
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  // min-height: calc(100% + 50px + 5vh); //基础高度 + 按键高度 + margin
  .timeImg {
    // filter: alpha(opacity=100, finishopacity=0, style=2);
  }
  .modal_header {
    color: #444444;

    &__title {
      font-size: 18px;
      text-align: center;
      line-height: 50px;
    }

    &__info {
      font-size: 28px;
      text-align: center;
      line-height: 50px;
      font-weight: 600;
      font-family: SourceHanSansCN-Bold;
    }

    &__countdown {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      line-height: 50px;
      text-align: center;
    }
  }

  .bottom {
    margin: 20px auto 20px;
  }

  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
}
</style>